'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_navigation_LegacyButton_BaseButton = require('../LegacyButton/BaseButton.cjs.js');

function BaseIconButton(_a) {
  var { icon, isCircle, label, shouldCorrectTooltipPosition, tooltipId, tooltipPosition } = _a, buttonProps = tslib_es6.__rest(_a, ["icon", "isCircle", "label", "shouldCorrectTooltipPosition", "tooltipId", "tooltipPosition"]);
  return jsxRuntime.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: label, position: tooltipPosition, shouldCorrectPosition: shouldCorrectTooltipPosition, showTooltipOnTouchDevices: false, tooltipId, children: ({ childProps }) => jsxRuntime.jsx(components_navigation_LegacyButton_BaseButton.BaseButton, Object.assign({ "aria-label": label }, buttonProps, childProps, { isPill: isCircle, isSquare: true, children: jsxRuntime.jsx(components_display_Icon_Icon.Icon, { canAcceptPointerEvents: false, isBlock: true, name: icon }) })) });
}

exports.BaseIconButton = BaseIconButton;
//# sourceMappingURL=BaseIconButton.cjs.js.map
